import { useGoogleMapsLoader } from 'app/utils/hooks/useGoogleMapsLoader'
import React, { createContext, useContext } from 'react'

type MapContextValue = {
  isLoaded: boolean
}

const MapContext = createContext<MapContextValue>({ isLoaded: false })

export const useMapProvider = () => useContext(MapContext)

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoaded, loadError } = useGoogleMapsLoader()

  if (loadError) return <div>Map load error</div>
  if (!isLoaded) return <div>Loading map...</div>

  return <MapContext.Provider value={{ isLoaded }}>{children}</MapContext.Provider>
}